import { render } from "./CommercialView.vue?vue&type=template&id=45a06aea&scoped=true"
import script from "./CommercialView.vue?vue&type=script&lang=js"
export * from "./CommercialView.vue?vue&type=script&lang=js"

import "./CommercialView.vue?vue&type=style&index=0&id=45a06aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a06aea"]])

export default __exports__